module.exports = __webpack_public_path__ + "img/amx-15.9104f951.jpg";